// @ts-nocheck

import { createStore, applyMiddleware } from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import thunk from 'redux-thunk'
import storage from 'redux-persist/lib/storage'
import { composeWithDevTools } from 'redux-devtools-extension'
import * as Sentry from '@sentry/react'

// middlewares
import createSagaMiddleware from 'redux-saga'
import runSagas from './middleware/sagas'
import apiMiddlware from './middleware/api'
import rootReducer from './reducers'

const persistConfig = {
  key: 'root',
  storage,
  timeout: null,
  whitelist: ['campaigns', 'sessionNotifications'],
}

// @ts-ignore
const persistedReducer = persistReducer(persistConfig, rootReducer)

// @ts-ignore
export default () => {
  const sagaMiddleware = createSagaMiddleware()

  const middlewares = [apiMiddlware, sagaMiddleware, thunk]
  const sentryReduxEnhancer = Sentry.createReduxEnhancer()

  const enhancer = composeWithDevTools({ trace: true, traceLimit: 25 })

  const store = createStore(
    persistedReducer,
    enhancer(applyMiddleware(...middlewares))
  )

  const persistor = persistStore(store)

  runSagas(sagaMiddleware)

  return { store, persistor }
}
